@import 'styles/mixins';
@import 'styles/variables';

.leftSlideIn {
  transform: translateX(100%);
  opacity: 0;
}

.leftSlideInActive {
  opacity: 1;
  transform: translateX(0);
  @include rightRailTransition(transform, opacity);
}

.leftSlideOut {
  opacity: 1;
  transform: translateX(0);
}

.leftSlideOutActive {
  opacity: 0;
  transform: translateX(100%);
  @include rightRailTransition(transform, opacity);
}

.upSlideIn {
  transform: translateY(100%);
  opacity: 0;
}

.upSlideInActive {
  opacity: 1;
  transform: translateY(0);
  @include rightRailTransition(transform, opacity);
}

.upSlideOut {
  opacity: 1;
  transform: translateY(0);
}

.upSlideOutActive {
  opacity: 0;
  transform: translateY(100%);
  @include rightRailTransition(transform, opacity);
}
